import {
  ConfirmInvitationResponse,
  getUserFromToken,
  GetUserFromTokenResponse,
  GetUserFromTokenPayload,
  ConfirmInvitationPayload,
  confirmInvitation,
} from 'app/api/confirmInvitation'
import { AxiosError } from 'axios'
import { ApiError } from 'EstraSponsor'
import {
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from 'react-query'

type UseGetUserFromToken = {
  data: GetUserFromTokenPayload
  executeOnStart: boolean
}

export const useGetUserFromToken = ({
  data,
  executeOnStart,
}: UseGetUserFromToken): UseQueryResult<
  GetUserFromTokenResponse,
  AxiosError<ApiError>
> => {
  return useQuery(['invitedUser'], () => getUserFromToken(data), {
    enabled: executeOnStart,
  })
}

export const useConfirmInvitation = (): UseMutationResult<
  ConfirmInvitationResponse,
  AxiosError<ApiError>,
  ConfirmInvitationPayload
> => {
  {
    return useMutation(confirmInvitation)
  }
}
